import { render, staticRenderFns } from "./CreaGruppo.vue?vue&type=template&id=5bb70158&"
import script from "./CreaGruppo.vue?vue&type=script&lang=js&"
export * from "./CreaGruppo.vue?vue&type=script&lang=js&"
import style0 from "./CreaGruppo.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports